import { State } from "../State/State";

/**
 * Load screen
 */
export abstract class LoadScreen extends State {
    protected _autoProgress: boolean;

    constructor() {
        super();
        this._autoProgress = true;
    }

    /**
     * onLoadProgress
     * @param pLoader
     * @param pResource
     */
    public onLoadProgress(pLoader: PIXI.loaders.Loader, pResource: PIXI.loaders.Resource, pLoaderIndex?: number): void;

    /**
     * onLoadProgress
     * @param pLoader.progress a number between 0 and 100
     * @param pResource the resource that was loaded. This will be `undefined` for audio files
     * @param pLoaderIndex which loader this is, starting at zero
     */
    public onLoadProgress(
        pLoader: {progress: number},
        pResource?: {name: string, url: string},
        pLoaderIndex?: number,
    ): void;

    public onLoadProgress(
        pLoader: PIXI.loaders.Loader | {progress: number},
        pResource: PIXI.loaders.Resource | {name: string, url: string} | undefined,
        pLoaderIndex: number = 0,
    ): void {
        // override
    }

    /**
     * onLoadComplete
     * @param pCallback
     */
    public onLoadComplete(pCallback: () => void): void {
        pCallback();
    }

    /**
     * autoProgress
     */
    public get autoProgress(): boolean {
        return this._autoProgress;
    }
}

export type LoadScreenProvider = LoadScreen | (() => LoadScreen);
